<template>
  <div class="item">
    <div class="flex items-center px-10 lg:px-6 flex-col md:flex-row">
      <div class="w-full md:w-1/5 ">
        <router-link :to="{ name: 'detail', params: { category: routeType, id: downloadData.id } }" class="outer w-full">
          <img :src="computedCover" class="w-full object-contain block cover" v-if="isLoaded">
          <vue-content-loading :width="300" :height="220" v-else>
            <rect cx="30" cy="30" width="200" r="30" height="220" x="50" />
          </vue-content-loading>
        </router-link>
      </div>
      <div class="w-full h-full md:w-4/5 pl-2 bg-white rounded-b lg:rounded-b-none lg:rounded-r flex flex-col justify-center leading-normal">
        <div class="listTitle flex items-center">
          <div class="title text-NotoSansRegular text-lg lg:text-xl">
            <h5 class="mb-0 tracking-wider">{{ downloadData.name }}</h5>
          </div>
        </div>
        <div class="listContent">
          <div class="degree flex flex-no-wrap">
            <div class="title-content text-NotoSansRegular flex flex-col md:flex-row">
              <span v-if="downloadData.edition">{{ downloadData.edition }}</span>
              <span class="mx-1 hidden md:block" v-if="downloadData.edition">|</span>
              <span v-if="downloadData.published_at">出版日期: {{ moment(downloadData.published_at).format('YYYY/MM/DD') }}</span>
            </div>
          </div>

          <div class="downloadFiles mb-4 flex-wrap hidden lg:flex">
            <div class="downloadBtn mt-4 mb-0 mx-0 flex justify-start items-center text-xs flex-no-wrap">
              <a :href="lifePenFile[0].url" class="btn cursor-pointer h-10 rounded-full text-xs flex items-center pl-1 pr-3"
                v-if="lifePenFile && lifePenFile.length > 0">
                <div class="h-8 w-8 mr-1 relative">
                  <img class="w-full h-full object-cotain btn-img absolute" src="~@/assets/images/readingPen/livepen-small.png"
                  alt="LiveABC點讀音檔下載" style="clip-path: circle(50% at 50% 50%);">
                </div>
                <div class="btn-content leading-tight">
                  <p class="m-0 whitespace-no-wrap tracking-tight" v-if="downloadData.category_id === 141 || downloadData.category_id === 167">字典卡</p>
                  <p class="m-0 whitespace-no-wrap tracking-tight"  v-if="downloadData.category_id !== 141 && downloadData.category_id !== 167">LiveABC點讀筆</p>

                  <p class="m-0 whitespace-no-wrap">ECM音檔下載</p>
                  <!-- <p class="m-0 whitespace-no-wrap tracking-tight"  v-if="downloadData.id !== 6559">LiveABC點讀筆</p>
                  <p class="m-0 whitespace-no-wrap" v-if="downloadData.id !== 6559">ECM音檔下載</p> -->
                </div>
              </a>

              <a :href="myVoiceFile[0].url" class="btn cursor-pointer h-10 rounded-full text-xs flex items-center pl-1 pr-3"
                v-if="myVoiceFile && myVoiceFile.length > 0">
                <div class="h-8 w-8 mr-1 relative">
                  <img class="w-full h-full object-cotain btn-img absolute" src="~@/assets/images/bluetooth_pen/bluetooth_pen.png"
                    alt="MyVoice點讀音檔下載" style="clip-path: circle(50% at 50% 50%);">
                </div>
                <div class="btn-content leading-tight">
                  <p class="m-0 whitespace-no-wrap" v-if="downloadData.category_id === 141 || downloadData.category_id === 167">字典卡</p>
                  <p class="m-0 whitespace-no-wrap"  v-if="downloadData.category_id !== 141 && downloadData.category_id !== 167">LiveABC點讀筆</p>
                  <p class="m-0 whitespace-no-wrap">BNL音檔下載</p>
                </div>
              </a>

              <a :href="Mp3File[0].url" class="btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap px-6"
                v-if="Mp3File && Mp3File.length > 0">
                MP3音檔下載
              </a>

              <a :href="JLPTFile[0].url" class="btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap px-6"
                v-if="JLPTFile && JLPTFile.length > 0">
                JLPT模擬試題下載
              </a>

              <router-link :to="{ name: 'detail', params: { category: routeType, id: downloadData.id } }" class="btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap px-8">
                更多介紹
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="downloadFiles flex mb-4 flex-wrap lg:hidden" v-if="$store.state.nodeEnv === 'production'">
      <div class="downloadBtn mt-4 flex justify-start items-center text-xs flex-col w-full px-10">
        <a class="btn cursor-pointer h-10 rounded-full text-xs flex items-center pl-1 pr-3 w-full my-1"
          @click.prevent="downloadPenFile('LIVEPEN_FILE')"
          v-if="(downloadData.attaches.filter(item => item.type === 'LIVEPEN_FILE')).length > 0">
          <div class="h-8 w-8 mr-1 relative">
            <img class="w-full h-full object-cotain btn-img absolute" src="~@/assets/images/readingPen/livepen-small.png"
              alt="LiveABC 點讀筆 點讀音檔下載">
          </div>
          <div class="btn-content leading-tight w-full">
              <p class="m-0 whitespace-no-wrap text-center" v-if="downloadData.id === 6559">字典卡點讀音檔</p>
              <p class="m-0 whitespace-no-wrap text-center"  v-if="downloadData.id !== 6559">LiveABC 點讀筆 點讀音檔下載</p>
          </div>
        </a>
        <a class="btn cursor-pointer h-10 rounded-full text-xs flex items-center pl-1 pr-3 w-full my-1"
          @click.prevent="downloadPenFile('LIVEPEN_FILE_2')"
          v-if="(downloadData.attaches.filter(item => item.type === 'LIVEPEN_FILE_2')).length > 0">
          <div class="h-8 w-8 mr-1 relative">
            <img class="w-full h-full object-cotain btn-img absolute" src="~@/assets/images/readingPen/myvoice-small.png"
              alt="MyVoice 點讀音檔下載">
          </div>
          <div class="btn-content leading-tight w-full">
            <p class="m-0 whitespace-no-wrap text-center">MyVoice 點讀音檔下載</p>
          </div>
        </a>
        <a class="btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap px-2 w-full my-1"
          @click.prevent="downloadPenFile('MP3')"
          v-if="(downloadData.attaches.filter(item => item.type === 'MP3')).length > 0">MP3音檔下載</a>
        <router-link :to="{ name: 'detail', params: { category: routeType, id: downloadData.id } }" class="btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap px-2 w-full my-1">
          更多介紹
        </router-link>
      </div>
    </div> -->
    <div class="downloadFiles flex mb-4 flex-wrap lg:hidden">
      <div class="downloadBtn mt-4 flex justify-start items-center text-xs flex-col w-full px-10">
        <a class="btn cursor-pointer h-10 rounded-full text-xs flex items-center pl-1 pr-3 w-full my-1"
          :href="lifePenFile[0].url"
          v-if="(downloadData.attaches.filter(item => item.type === 'LIVEPEN_FILE')).length > 0">
          <div class="h-8 w-8 mr-1 relative">
            <img class="w-full h-full object-cotain btn-img absolute" src="~@/assets/images/readingPen/livepen-small.png"
              alt="LiveABC 點讀筆 點讀音檔下載">
          </div>
          <div class="btn-content leading-tight w-full">
              <p class="m-0 whitespace-no-wrap text-center" v-if="downloadData.category_id === 141 || downloadData.category_id === 167">字典卡點讀音檔</p>
              <p class="m-0 whitespace-no-wrap text-center"  v-if="downloadData.category_id !== 141 && downloadData.category_id !== 167">LiveABC 點讀筆 點讀音檔下載</p>
          </div>
        </a>

        <a class="btn cursor-pointer h-10 rounded-full text-xs flex items-center pl-1 pr-3 w-full my-1"
          :href="myVoiceFile[0].url"
          v-if="(downloadData.attaches.filter(item => item.type === 'LIVEPEN_FILE_2')).length > 0">
          <div class="h-8 w-8 mr-1 relative">
            <img class="w-full h-full object-cotain btn-img absolute" src="~@/assets/images/readingPen/myvoice-small.png"
              alt="MyVoice 點讀音檔下載">
          </div>
          <div class="btn-content leading-tight w-full">
            <p class="m-0 whitespace-no-wrap text-center">MyVoice 點讀音檔下載</p>
          </div>
        </a>

        <a class="btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap px-2 w-full my-1"
          :href="Mp3File[0].url"
          v-if="(downloadData.attaches.filter(item => item.type === 'MP3')).length > 0">MP3音檔下載</a>

        <a class="btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap px-2 w-full my-1"
          :href="JLPTFile[0].url"
          v-if="(downloadData.attaches.filter(item => item.type === 'JLPT_TEST')).length > 0">LPT模擬試題下載</a>

        <router-link :to="{ name: 'detail', params: { category: routeType, id: downloadData.id } }" class="btn cursor-pointer h-10 rounded-full text-xs flex items-center justify-center whitespace-no-wrap px-2 w-full my-1">
          更多介紹
        </router-link>
      </div>
    </div>
    <hr class="my-3 md:my-4 border-t">
  </div>
</template>

<script>
import VueContentLoading from 'vue-content-loading'
export default {
  name: 'FileItem',
  data () {
    return {
      isLoaded: false
    }
  },
  props: {
    downloadData: {
      type: Object
    }
  },
  watch: {
    '$props.downloadData': {
      handler (newVal, oldVal) {
        if (newVal.cover || newVal.cover !== oldVal.cover) {
          this.onImageLoaded()
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    VueContentLoading
  },
  computed: {
    computedCover () {
      let self = this
      if (self.downloadData && self.downloadData.cover) {
        return self.downloadData.cover
      } else {
        return require('@/assets/images/preset_item_small.png')
      }
    },
    routeType () {
      let self = this
      if (self.downloadData.type === 'PACKAGE' || self.downloadData.type === 'ITEM') {
        // 套書
        return 'package'
      } else if (self.downloadData.type === 'MAGAZINE' || self.downloadData.type === 'PLAN') {
        // 雜誌
        return 'magazine'
      } else {
        return 'book'
      }
    },
    lifePenFile () {
      let self = this
      return self.downloadData.attaches.filter(item => item.type === 'LIVEPEN_FILE')
    },
    myVoiceFile () {
      let self = this
      return self.downloadData.attaches.filter(item => item.type === 'LIVEPEN_FILE_2')
    },
    Mp3File () {
      let self = this
      return self.downloadData.attaches.filter(item => item.type === 'MP3')
    },
    JLPTFile () {
      let self = this
      return self.downloadData.attaches.filter(item => item.type === 'JLPT_TEST')
    }
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    // downloadPenFile (type) {
    //   let self = this
    //   if (type === 'LIVEPEN_FILE') {
    //     for (let item of self.lifePenFile) {
    //       window.open(item.url)
    //     }
    //   } else if (type === 'LIVEPEN_FILE_2') {
    //     for (let item of self.myVoiceFile) {
    //       window.open(item.url)
    //     }
    //   } else if (type === 'MP3') {
    //     for (let item of self.Mp3File) {
    //       window.open(item.url)
    //     }
    //   }
    // },
    onImageLoaded () {
      let self = this
      self.isLoaded = false
      var image = new Image()
      image.src = self.downloadData.cover

      if (image.complete) {
        self.isLoaded = true
      } else {
        image.onload = () => {
          self.isLoaded = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .item {
    .outer {
      .cover {
        max-height: 144px;
      }
      img[lazy=loading] {
        width: 2rem !important;
        height: 2rem !important;
        margin-top: 3.5rem !important;
      }
    }

    .listTitle {
      .title {
        font-weight: 500;
        color: #e60012;
      }
    }
    .listContent {
      .degree, .target {
        .title-content {
          font-size: 14px;
          color: #434343;
        }
      }
      .downloadBtn {
        .btn {
          background-color: white;
          border: 1px solid black;
          color: #434343;
          font-size: 14px;
          font-weight: 400;
          margin: 0 .2rem;
          .btn-img {
            top: 0;
            right: 0;
            background-color: #FDEDED;
            clip-path: circle(50% at 50% 50%);
            -webkit-clip-path: circle(50% at 50% 50%);
          }
          &:hover {
            background-color: #e60012;
            color: white;
            border: 1px solid #e60012;
            .btn-img {
              background-color: white;
            }
          }
        }
      }
    }
    hr {
      border-top-color: #504f4f;
    }
    .downloadFiles {
      .downloadBtn {
        .btn {
          background-color: white;
          border: 1px solid black;
          color: #434343;
          font-size: 14px;
          font-weight: 400;
          margin: 0 .2rem;
          .btn-img {
            top: 0;
            right: 0;
            background-color: #FDEDED;
            clip-path: circle(50% at 50% 50%);
            -webkit-clip-path: circle(50% at 50% 50%);
          }
          .btn-content {
          }
          &:hover {
            background-color: #e60012;
            color: white;
            border: 1px solid #e60012;
            .btn-img {
              background-color: white;
            }
          }
        }
      }
    }
  }
</style>
